const Signup = {
    title: 'Sign Up',
    already_have_an_account_login: 'Already have an account? Log In'
}
export default Signup;
